module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_m_erythristic.9d3ad26e.png";